import { OrganizationUnit } from '@inplay/models';
import { getEnvironmentVariable } from '../helper/config';
import apiClient from '../utils/apiClient';
import axiosClient from '../utils/apiClient';
import { isApiError } from '../utils/helper';
import { EnvVariables } from '../utils/helper.type';
import { AxiosResponse } from 'axios';

export class OrganizationService {
  private baseApi: string;

  constructor() {
    const baseURL: string | undefined = axiosClient.defaults.baseURL;

    if (!baseURL) {
      throw new Error('baseURL is not defined in axiosClient.');
    }

    this.baseApi = baseURL;
  }

  public async getOrganizationUnits(): Promise<
    (OrganizationUnit & { _id: string })[]
  > {
    try {
      console.log(`[ENTRY][OrganizationService][organizationUnit][ENTRY]`);

      const oraganizationApiResource: string = getEnvironmentVariable(
        EnvVariables.REACT_APP_ORGANIZATION_UNIT_RESOURCE,
      );
      const organizationApiEndpoint: string = `${this.baseApi}${oraganizationApiResource}`;
      const organizationApiResponse: AxiosResponse<
        (OrganizationUnit & { _id: string })[]
      > = await apiClient.get(organizationApiEndpoint);

      console.log(`[OrganizationService][organizationUnit]`, {
        organizationApiResponse,
      });
      const organizationUnits: (OrganizationUnit & { _id: string })[] =
        organizationApiResponse.data;
      console.log(`[EXIT][getOrganizationUnits][OrganizationUnits]`, {
        organizationUnits,
      });
      return organizationUnits;
    } catch (error: unknown) {
      console.error(`[getOrganizationUnits][OrganizationUnits][ERROR]`, {
        error,
      });

      if (isApiError(error)) {
        throw error;
      }

      throw error;
    }
  }
}
